import { ADVISOR_ENGAGEMENT_FRAGMENT } from '@src/gql/fragments/AdvisorEngagementFragment'
import { gql } from '@src/lib/gql'

export const END_ADVISOR_ENGAGEMENT = gql`
  mutation EndAdvisorEngagement($input: EndAdvisorEngagementInput!) {
    endAdvisorEngagement(input: $input) {
      advisorEngagement {
        ...AdvisorEngagementFragment
      }
    }
  }
  ${ADVISOR_ENGAGEMENT_FRAGMENT}
`
